import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getIndices = () => client.get("/indices").then((r) => r.data);
export const getScanner = (category = "all", sort = "rel_volume") =>
  client.get("/scanner", { params: { category, sort } }).then((r) => r.data);
export const getTicker = (symbol) => client.get(`/ticker/${symbol}`).then((r) => r.data);
export const getOptions = (symbol, dte = 14) =>
  client.get(`/options/${symbol}`, { params: { dte } }).then((r) => r.data);
export const getCandles = (symbol, resolution = 5, count = 78) =>
  client.get(`/candles/${symbol}`, { params: { resolution, count } }).then((r) => r.data);
export const getAlerts = (limit = 50) => client.get("/alerts", { params: { limit } }).then((r) => r.data);
export const scanNow = () => client.post("/alerts/scan").then((r) => r.data);
export const getWatchlist = () => client.get("/watchlist").then((r) => r.data);
export const addWatch = (symbol) => client.post("/watchlist", { symbol }).then((r) => r.data);
export const removeWatch = (symbol) => client.delete(`/watchlist/${symbol}`).then((r) => r.data);
export const getSettings = () => client.get("/settings").then((r) => r.data);
export const saveSettings = (s) => client.put("/settings", s).then((r) => r.data);
export const testEmail = (email) => client.post("/settings/test-email", { email }).then((r) => r.data);
export const getSentiment = (symbol) => client.post(`/ai/sentiment/${symbol}`).then((r) => r.data);

export const getSymbols = () => client.get("/symbols").then((r) => r.data);
export const getStrategies = (symbol, dte = 14) =>
  client.get(`/strategies/${symbol}`, { params: { dte } }).then((r) => r.data);
export const getRuleFirings = (id, limit = 25) =>
  client.get(`/rules/${id}/firings`, { params: { limit } }).then((r) => r.data);
export const getRuleTemplates = () => client.get("/rules/templates").then((r) => r.data);
export const getEarnings = () => client.get("/earnings").then((r) => r.data);
export const getRules = () => client.get("/rules").then((r) => r.data);
export const createRule = (rule) => client.post("/rules", rule).then((r) => r.data);
export const updateRule = (id, patch) => client.put(`/rules/${id}`, patch).then((r) => r.data);
export const deleteRule = (id) => client.delete(`/rules/${id}`).then((r) => r.data);
export const STREAM_URL = `${API}/stream`;

export const fmtNum = (n) => {
  if (n === null || n === undefined) return "—";
  if (Math.abs(n) >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(2) + "M";
  if (Math.abs(n) >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return String(n);
};
export const fmtPrice = (n) => (n >= 1 ? n.toFixed(2) : n.toFixed(4));
